<template>
  <div>
    <ButtonX />
    <b-container>
      <h1>Über Uns</h1>
      <p>
        Wir sind ein Geschichtsgrundkurs vom
        <a href="https://www.gak-speyer.de">(click)</a> Gymnasium am Kaiserdom Speyer und werden unser Abitur im Jahrgang 2021/22 machen. Im Rahmen des Geschichtsunterrichts haben wir uns dieses Jahr insbesondere aufgrund des 30-jährigen Jubiläums mit den Ereignissen rund um die deutsche Wiedervereinigung befasst. Unsere Ergebnisse haben wir hier in digitaler Form für die Nachwelt festeghalten.
      </p>
      <p>An diesem Projekt haben sehr viele Menschen mitgewirkt. Diese sind hier aufgeführt.</p>
      <h1>Danke!</h1>
      <p>Wir möchten uns bedanken bei:</p>
      <div class="thanks">
        <p>
          <b>Frau Krause</b>, unserer Geschichtslehrerin für die kompetente fachliche Begleitung
        </p>
        <p>
          <b>allen Interviewpartnern</b> für die Zeitzeugenberichte, die unsere Recherche und diese seite sehr bereichert haben
        </p>
        <p>
          <b>allen Teilnehmern</b> für das Ausfüllen der Umfragen, die einigen unserer Seiten zu Grunde lagen
        </p>
        <p>
          <b>Herrn Sütterlin, Herr Müller M. und Jan Dopheide</b> für die Unterstützung bei der technischen und rehctlichen Umsetzung
        </p>
      </div>
      <p>Außerdem möchten wir an dieser Stelle auflisten wer für welche Teile dieses Projektes verantwortlich gewesen ist:</p>
      <div class="thanks">
        <p>
          <b>Alexander Kühling und Anton Willimsky</b> - Montagsdemos
        </p>
        <p>
          <b>Chiara Müller, Mia-Sophie Stadler</b> - Wirtschaftliche Folgen
        </p>
        <p>
          <b>Anna-Sophia Zegermacher und Benedikt von Pückler</b> - Gesellschaftliche Folgen
        </p>
        <p>
          <b>Emilia Cinova, Michelle Gerlow-Weiss und Sarah Fischer</b> - Politische Entwicklung
        </p>
        <p>
          <b>Lorena Rampe und Marret Schlette-Kissling</b> - Tag des Mauerfalls
        </p>
        <p>
          <b>Caroline Honcza und Isabel Sohn</b> - Hoffnung und Realität der Wiedervereinigung
        </p>
        <p>
          <b>Johanna Hintermayr und Lilli Reimer</b> - Unsere Sicht auf die Wiedervereinigung, Wie gut kennen wir einander?
        </p>
        <p>
          <b>Linus Venzke</b> - Wie wurde die Wiedervereinigung und der Mauerfall präsentiert?
        </p>
        <p>
          <b>Maximilian Wittmer und David Sauer</b> - Organisation, technische Umsetzung, Sonstiges
        </p>
      </div>
      <Footer />
    </b-container>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>